module.exports = __webpack_public_path__ + "static/img/4.79ffb335.png";